module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0729deeeab0ba3942fba6f70ed338969.png";